// Marketing → Emails: email templates (UI.Admin EmailsController). The list is fetched once and reused; an edit on
// the detail page replaces that template's row so the list's Draft / Unpublished changes chips stay current.
const state = {
  list: [],
  email: {}
};

const getters = {
  list: (state) => state.list || [],
  email: (state) => state.email || {}
};

const toSummary = (detail) => ({
  key: detail.key,
  name: detail.name,
  sentWhen: detail.sentWhen,
  kind: detail.kind,
  version: detail.version,
  publishedAt: detail.publishedAt,
  hasDraft: detail.hasDraft
});

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_EMAIL(state, detail) {
    state.email = detail;
    if (!detail || !detail.key) return;
    const exists = (state.list || []).some((x) => x.key === detail.key);
    state.list = exists
      ? state.list.map((x) => (x.key === detail.key ? toSummary(detail) : x))
      : [toSummary(detail)].concat(state.list || []);
  }
};

const post = (vm, action, payload) => vm.$http.post(`emails/${action}`, payload).then((r) => r.data);

const actions = {
  getList({ commit }) {
    return this._vm.$http.get('emails/getAll').then((r) => {
      commit('SET_LIST', r.data);
      return r.data;
    });
  },
  get({ commit }, key) {
    return this._vm.$http.get('emails/get', { params: { key } }).then((r) => {
      commit('SET_EMAIL', r.data);
      return r.data;
    });
  },
  // Renders the editor's words with the real renderer; never changes anything.
  preview(_, payload) {
    return post(this._vm, 'preview', payload);
  },
  saveDraft({ commit }, payload) {
    return post(this._vm, 'saveDraft', payload).then((detail) => {
      commit('SET_EMAIL', detail);
      return detail;
    });
  },
  publish({ commit }, payload) {
    return post(this._vm, 'publish', payload).then((result) => {
      commit('SET_EMAIL', result.detail);
      return result;
    });
  },
  sendTest(_, payload) {
    return post(this._vm, 'sendTest', payload);
  },
  restore({ commit }, payload) {
    return post(this._vm, 'restore', payload).then((detail) => {
      commit('SET_EMAIL', detail);
      return detail;
    });
  },
  // Starts the background import of Customer.io's unsubscribes and bounces; the result arrives by email.
  importFromCustomerIo() {
    return post(this._vm, 'importFromCustomerIo', {});
  },
  create({ commit }, payload) {
    return post(this._vm, 'create', payload).then((detail) => {
      commit('SET_EMAIL', detail);
      return detail;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
